
import { User } from 'firebase/auth';
import { 
  collection, 
  query, 
  where, 
  getDocs, 
  DocumentData,
  setDoc,
  doc
} from 'firebase/firestore';
import { db } from '@/lib/firebase';
import { UserType } from './types';

// Helper function to find Ahavexer by ahavexId
export const findAhavexerByAhavexId = async (ahavexId: string): Promise<DocumentData | null> => {
  try {
    const usersRef = collection(db, 'users');
    const q = query(usersRef, where('ahavexId', '==', ahavexId));
    const querySnapshot = await getDocs(q);
    
    if (!querySnapshot.empty) {
      return querySnapshot.docs[0].data();
    }
    return null;
  } catch (error) {
    console.error('Error finding ahavexer:', error);
    return null;
  }
};

// Helper to check if a user has admin role
export const checkAdminRole = async (uid: string): Promise<boolean> => {
  try {
    const usersRef = collection(db, 'users');
    const q = query(usersRef, where('uid', '==', uid), where('role', '==', 'admin'));
    const querySnapshot = await getDocs(q);
    
    return !querySnapshot.empty;
  } catch (error) {
    console.error('Error checking admin role:', error);
    return false;
  }
};

// Helper to persist auth session data
export const persistUserSession = (user: User | null, type: UserType) => {
  if (user) {
    // Store only necessary user info
    const userToStore = {
      uid: user.uid,
      email: user.email,
      displayName: user.displayName,
      photoURL: user.photoURL
    };
    localStorage.setItem('authUser', JSON.stringify(userToStore));
    localStorage.setItem('userType', type as string);
  } else {
    localStorage.removeItem('authUser');
    localStorage.removeItem('userType');
  }
};

// Helper to save user data to Firestore
export const saveUserToFirestore = async (uid: string, userData: any) => {
  try {
    const userRef = doc(db, 'users', uid);
    await setDoc(userRef, {
      ...userData,
      lastUpdated: new Date().toISOString()
    });
    return true;
  } catch (error) {
    console.error('Error saving user to Firestore:', error);
    throw error;
  }
};
